import React, { ReactNode } from 'react';
import ErrorBoundary from '@/components/common/ErrorBoundary';

type SignalRErrorBoundaryProps = {
  children: ReactNode;
};

export const SignalRErrorBoundary: React.FC<SignalRErrorBoundaryProps> = ({ children }) => (
  <ErrorBoundary fallback={null}>
    {children}
  </ErrorBoundary>
);
